__turbopack_context__.v({
  "container": "ImageTag-module-scss-module__d9juXW__container",
  "imgTagTextContainer": "ImageTag-module-scss-module__d9juXW__imgTagTextContainer",
});
